<template>
  <div class="PersonalLeaseOrder">
    <!-- tabs -->
    <!-- eslint-disable-next-line vue/no-mutating-props -->
    <el-tabs type="card" v-model="echoParams.childActiveName" @tab-click="handleTab">
      <el-tab-pane
        v-for="(item, index) of c_personalTabsList"
        :label="`${item.label}(${item.number})`"
        :name="item.name"
        :key="index"
      />
    </el-tabs>
    <!-- 筛选&table -->
    <base-list-management
      ref="baseListManagement"
      :configData.sync="m_configData"
      >
      <PublicExport
        slot="custom-export"
        v-if="judgePermission('for_rent_sign_contract_rent_order_export')"
        exportTitle="导出"
        exportTemplate="Tenant"
        :getSearchData="searchParams"
        templateCode="vehicle-workbench-rent-order"
        :getSearchCondition="getSearchCondition"
      />
      <div slot="custom-operate">
        <el-button
          type="primary"
          size="small"
          class="whole_contract_btn"
          v-if="judgePermission('for_rent_sign_contract_rent_order_create')"
          @click="addSignContract"
        >个人签约提车</el-button>
        <el-button
          type="primary"
          size="small"
          @click="batchImportOrder"
          v-if="judgePermission('for_rent_sign_contract_rent_order_batch_import')"
        >批量导入订单</el-button>
      </div>
    </base-list-management>

    <!-- 解约支付宝、网约代扣 -->
    <UnBindWithhold ref="unBindWithholdRef" @update="goSearch"/>
    <!-- 签约网约钱包支付抽屉 -->
    <SignWithholdDrawer ref="signWithholdDrawerRef" @complete="goSearch" />
    <!-- 签约支付宝支付抽屉 -->
    <signAlipayWithholdDrawer ref="signAlipayWithholdDrawerRef" @update="goSearch" />

    <dialogWrap
      v-model="msgDialogVisible"
      :before-close="closeMsgDialogVisible"
      title="提示"
      :width="'524px'"
      >
      <div>未开通网约钱包支付功能</div>
      <template slot="footer">
        <el-button type="primary" size="small" @click="closeMsgDialogVisible"
          >确定</el-button
        >
      </template>
    </dialogWrap>

    <!-- 取消订单弹框 -->
    <el-dialog
      title="取消原因"
      :visible.sync="cancelDialogVisible"
      width="400px"
      >
      <div class="radioGroup">
        <el-radio-group v-model="closeReason">
          <el-radio label="账户资金不足">账户资金不足</el-radio>
          <el-radio label="签约失败">签约失败</el-radio>
          <el-radio label="交付信息有误">交付信息有误</el-radio>
          <el-radio label="不想租车了">不想租车了</el-radio>
          <el-radio label="信息填写错误">信息填写错误</el-radio>
          <el-radio label="其他" value="其他">其他</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmCancel">确 定</el-button>
      </span>
    </el-dialog>

    <BatchImportOrder ref="batchImportOrder" />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import config from '../config'
// api
import { cancelOrder, getLeasingSchemeConfigListAll } from '@/api/domain/cars'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
// 其他
import UnBindWithhold from '@/pages/orders/components/UnBindWithhold.vue'
import { UNBIND_TITLE, WITHHOLD_TYPE } from '@/pages/orders/components/const'
import signAlipayWithholdDrawer from '@/pages/orders/components/paymentChannels/aliPay/index.vue'
import SignWithholdDrawer from '@/pages/orders/components/paymentChannels/driverIncomes/index.vue'
import { check } from '@/pages/orders/components/withholdCheck.js'
import { generateExportCondition } from '@/utils/exportUtils.js'
import { mapState } from 'vuex'
import orderConfig from '../config/personalLeaseOrderConfig'
import BatchImportOrder from './BatchImportOrder.vue'

export default {
  components: {
    UnBindWithhold,
    SignWithholdDrawer,
    signAlipayWithholdDrawer,
    BatchImportOrder,
  },
  props: {
    echoParams: {
      type: Object,
      default: () => ({}),
    },
    summaryList: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const {
      // 个人租赁订单tabs
      c_personalTabsList,
    } = config.call(this)
    const m_configData = orderConfig.call(this)
    // 保存原始columns配置，用于动态过滤
    const allColumns = [...m_configData.tableData.columns]
    return {
      c_personalTabsList,
      m_configData,
      allColumns,
      msgDialogVisible: false,
      cancelDialogVisible: false, // 订单取消弹窗flag
      closeReason: null, // 订单取消原因
      closeOrderId: null, // 取消的订单号
      // c_personalTabsList有引用
      // eslint-disable-next-line vue/no-unused-properties
      carConditionList: [],
      // c_personalTabsList有引用
      // eslint-disable-next-line vue/no-unused-properties
      customerConditionList: [],
    }
  },
  computed: {
    ...mapState({
      // 租赁模式
      categoryList: (state) => {
        const list = [...state.global.categoryList]
        list.unshift({
          code: '',
          name: '全部',
        })
        return list
      },
    }),
  },
  watch: {
    'echoParams.childActiveName': {
      handler() {
        this.filterColumns()
      },
      immediate: true,
    },
    categoryList: {
      handler(val) {
        // 设置租赁模式
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'list',
          key: 'rentCategory',
          data: val,
        })
      },
      deep: true,
    },
    summaryList: {
      handler(val) {
        this.c_personalTabsList.forEach((item) => {
          if (item.name === '1') {
            // 全部
            item.number = val?.toProcessOrderNum || 0
            return
          }
          if (item.name === '11') {
            // 订单待确认
            item.number = val?.toConfirmOrderNum || 0
            return
          }
          if (item.name === '12') {
            // 发车待验车
            item.number = val?.confirmedOrderNum || 0
            return
          }
          if (item.name === '13') {
            // 订单待支付
            item.number = val?.toPaymentOrderNum || 0
          }
          if (item.name === '5') {
            // 待绑车
            item.number = val?.toBindOrderNum || 0
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    // 根据当前tab过滤columns
    filterColumns() {
      const currentTab = this.echoParams?.childActiveName
      const filtered = this.allColumns.filter((col) => {
        // 下单手机号列仅在待绑车Tab(name='5')下展示
        if (col.name === 'customerSafetyTel') {
          return currentTab === '5'
        }
        return true
      })
      this.m_configData.tableData.columns = filtered
    },
    async getPlanList() {
      // orderType(类型) - 1:个人; 2:企业;
      const res = await getLeasingSchemeConfigListAll({ orderType: 1 })
      const data = res?.data || []
      const customerOption = {
        name: '自定义',
        id: 0,
      }
      data.unshift(customerOption)
      this.$refs.baseListManagement?.setItemData({
        elConfigKey: 'list',
        key: 'planId',
        data,
      })
    },
    // 个人签约提车
    addSignContract() {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
      })
    },
    // 关闭提示弹框
    closeMsgDialogVisible() {
      this.msgDialogVisible = false
    },
    goSearch() {
      this.$refs.baseListManagement.searchForm()
    },
    // 展示开启网约钱包支付 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    async showOpenWalletWithhold(row) {
      const { id: orderId, rentCategory } = row
      check(orderId, WITHHOLD_TYPE.WALLET).then(() => {
        this.$refs.signWithholdDrawerRef.openDrawer({ orderId, rentCategory })
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    showOpenAlipayWithhold(row) {
      check(row.id, WITHHOLD_TYPE.ALIPAY).then(() => {
        this.$refs.signAlipayWithholdDrawerRef.openDrawer(row)
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    showRescindAlipayWithhold(row, type) {
      this.$refs.unBindWithholdRef.open({
        title: UNBIND_TITLE[type],
        orderId: row.id,
        type, // 1:网约钱包支付 2:支付宝支付
      })
    },
    // 发车验车 config.js有调用
    // eslint-disable-next-line vue/no-unused-properties
    outInBankPop(row) {
      const { id } = row
      const query = { orderId: id, stepsActive: 4 }
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
        query,
      })
    },
    // 查看财务进度 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    toReceiptandpayment(row) {
      const { id } = row
      const query = { orderId: id, stepsActive: 3 }
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
        query,
      })
    },
    // 订单确认 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    toOrderConfirmPage(row) {
      const { id } = row
      const query = { orderId: id, stepsActive: 2 }
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
        query,
      })
    },
    // 退车解约 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    closeTheCar(row) {
      const query = {
        id: row.id,
        state: row.state,
        type: 5,
        returnInfoType: 2,
        orderType: 'personal',
      }
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/cancelContract',
        query,
      })
    },
    // 去租赁订单详情页面 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    toOrderDetailPage(query, hash) {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalDetail',
        query: {
          ...query,
          orderType: 'personal',
        },
        hash,
      })
    },
    // 车牌号模糊查询 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    carRemoteMethod(query) {
      if (query.length >= 4) {
        FuzzySearch({
          state: 1,
          plateNo: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'list',
            key: 'carId',
            data,
          })
        })
      }
    },
    // 客户模糊查询 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    customerRemoteMethod(query) {
      if (query.length >= 1) {
        searchByCustomerNameSensitive({
          customerState: 1,
          customerType: 1,
          customerName: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'list',
            key: 'customerId',
            data,
          })
        })
      }
    },
    // tabs切换
    handleTab() {
      this.$refs.baseListManagement.reset()
    },
    getRouteQuery() {
      const { deptId } = this.echoParams
      if (deptId) {
        this.m_configData.formData.formProps.model.deptIdList = [deptId]
      }
    },
    init() {
      this.getRouteQuery()
      // 获取租赁模式
      this.$store.dispatch('getPaymentMethods', { type: 'rentCategory' })
      // 获取租赁方案list(公司和集团)
      this.getPlanList()
    },
    // 去绑车 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    handleToBindCar(row) {
      this.$router.push({
        name: 'for_rent_sign_contract_rent_order_create',
        query: {
          orderId: row.id,
          source: 2,
          stepsActive: 1,
        },
      })
    },
    // 取消订单 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    handleCancelOrder(row) {
      this.closeOrderId = row.id
      this.closeReason = ''
      this.cancelDialogVisible = true
    },
    // 确认取消订单
    async handleConfirmCancel() {
      if (!this.closeReason) {
        this.$message.error('请选择取消原因')
        return
      }
      this.cancelDialogVisible = false
      const { code } = await cancelOrder({
        orderId: this.closeOrderId,
        closeReason: this.closeReason,
      })
      this.closeOrderId = null
      if (code === 1) {
        this.$message.success('订单取消成功！')
        // 刷新数据
        setTimeout(() => {
          this.$refs.baseListManagement.searchForm()
          this.$emit('getSummary')
        }, 1500)
      }
    },
    // 筛选参数处理 mixins有调用
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(val) {
      // 时间处理
      // 订单创建时间
      val.createTimeStart = (val.TheOrderStart && val.TheOrderStart[0]) || ''
      val.createTimeEnd = (val.TheOrderStart && val.TheOrderStart[1]) || ''
      // 订单确认时间
      val.confirmTimeStart =
        (val.TheOrderconfirmtime && val.TheOrderconfirmtime[0]) || ''
      val.confirmTimeEnd =
        (val.TheOrderconfirmtime && val.TheOrderconfirmtime[1]) || ''
      // 发车验车时间
      val.outStockTimeStart = (val.TheCarExTime && val.TheCarExTime[0]) || ''
      val.outStockTimeEnd = (val.TheCarExTime && val.TheCarExTime[1]) || ''
      // 计租结束日
      val.rentEndTimeStart = (val.rentFinIsh && val.rentFinIsh[0]) || ''
      val.rentEndTimeEnd = (val.rentFinIsh && val.rentFinIsh[1]) || ''
      // 免租结束日
      val.presentEntTimeStart =
        (val.freeCycleEndTime && val.freeCycleEndTime[0]) || ''
      val.presentEntTimeEnd =
        (val.freeCycleEndTime && val.freeCycleEndTime[1]) || ''
      // 预约到店时间
      val.bookTimeStart = (val.bookTime && val.bookTime[0]) || ''
      val.bookTimeEnd = (val.bookTime && val.bookTime[1]) || ''

      // 个人租赁订单固定参数
      val.bizType = 10 // 10个人订单 20企业子订单
      val.relatedType = 10 // 无关联原因
      val.tabNo = Number(this.echoParams.childActiveName) // tab
      return val
    },
    searchParams() {
      return this.$refs.baseListManagement?.getParams() || {}
    },
    getSearchCondition() {
      const params = this.searchParams()
      // input和日期没有值时不展示，其他没有值时展示全部
      const conditions = this.m_configData.formData.list.map((item) => {
        const {
          el,
          itemConfig: { label, prop: key },
        } = item
        const val = params[key]
        if (key === 'carId') {
          item.elConfig.options.list = this.carConditionList
        }
        if (key === 'customerId') {
          item.elConfig.options.list = this.customerConditionList
        }
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      // Tab需要放入导出的查询条件中
      conditions.push({
        label: '订单类型',
        matchValue: '个人租赁订单',
      })
      conditions.push({
        label: '订单状态',
        matchValue: this.c_personalTabsList.find((item) => String(item.name) === this.echoParams.childActiveName)?.label,
      })
      return conditions
    },
    batchImportOrder() {
      this.$refs.batchImportOrder.showDialog('personal')
    },
  },
}
</script>
<style lang="scss" scoped>
.radioGroup {
  padding-left: 20px;
  .el-radio-group {
    display: display;
    .el-radio {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
